module.exports = __webpack_public_path__ + "static/media/Picture11.f76db2bb.png";